module.exports = __webpack_public_path__ + "img/marker-point-marron.8f5bdd4f.png";